const legacyDocs = () => {
	const legacyToggle = document.querySelector('.legacy-docs-toggle-widget input');

	if (!legacyToggle) {
		return;
	}

	const setLegacyDocs = () => {
		document.body.classList.add('legacy-docs');
		document.body.classList.remove('default-docs');
		localStorage.setItem('legacyDocs', 'legacy');
	}

	const unsetLegacyDocs = () => {
		document.body.classList.remove('legacy-docs');
		document.body.classList.add('default-docs');
		localStorage.removeItem('legacyDocs');
	}

	const legacyDocsSetting = localStorage.getItem('legacyDocs');
	const urlParams = new URLSearchParams(window.location.search);

	if (legacyDocsSetting || true === urlParams.has('v3')) {
		legacyToggle.checked = true;
		setLegacyDocs();
	}

	if (true === urlParams.has('v4')) {
		legacyToggle.checked = false;
		unsetLegacyDocs();
	}

	window.addEventListener('click', (event) => {
		if (event.target.matches('.legacy-check')) {
			if (legacyToggle.checked) {
				setLegacyDocs();
			} else {
				unsetLegacyDocs();
			}
		}
	});
};

export default legacyDocs;